import { Logger } from './logger'

export const setLocalStorageWithExpiry = <T>(key: string, value: T, ttlInDays: number) => {
  const now = new Date()
  const expiry = new Date(now.getTime() + ttlInDays * 24 * 60 * 60 * 1000)
  const item = { value, expiry: expiry.toISOString() }
  localStorage.setItem(key, JSON.stringify(item))
}

export const getLocalStorageWithExpiry = <T>(key: string): T | null => {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) {
    return null
  }

  try {
    const item = JSON.parse(itemStr)
    const now = new Date()
    if (new Date(item.expiry) > now) {
      return item.value as T
    } else {
      localStorage.removeItem(key)
      return null
    }
  } catch (e) {
    Logger.instance.error('[local-storage] Error parsing item', { key, error: e })
    localStorage.removeItem(key)
    return null
  }
}
